    <div class="tw-flex tw-flex-col">
        <div id="venduto" class="tw-py-6 tw-px-6">
            <div class="tw-text-sm tw-text-black tw-px-2 tw-py-1 tw-w-min tw-rounded tw-bg-yellow-200 tw-font-bold" translate>HISTORY.SALES.DETAIL.SOLD</div>
            @for(saleItem of sale?.sale_items; track saleItem) {
                <div title="etichetta_prodotto" class="tw-flex-col tw-py-4">
                    <div class="tw-flex tw-flex-row tw-justify-between">
                        <div>{{(saleItem.name || '').toTitleCase()}}</div>
                        <div>{{(saleItem.price * saleItem.quantity) | tilbyCurrency}}</div>
                    </div>
                    @if(saleItem.type === 'gift') {
                        <div translate>HISTORY.SALE.GIFT</div>
                    }
                    <div class="sale-item-notes tw-flex tw-items-center tw-font-semibold">{{saleItem.quantity}}<span class="tw-text-[0.6rem] tw-m-[0.1rem]">x</span>{{saleItem.price}}</div>
                    @for(variation of saleItem.variations; track variation) {
                        <div class="tw-flex tw-flex-row tw-justify-between tw-text-xs tw-text-gray-600">
                            <span>{{variation.name}} - {{(variation.quantity ?? 1) > 1 ? variation.quantity + 'x ' : '' }}{{variation.value}}</span>
                            <span>{{ ((saleItem.quantity || 0) * (variation.price_difference || 0) * (variation.quantity ?? 1) | tilbyCurrency) || '-' }}</span>
                        </div>
                    }
                    @for(ingredient of saleItem.ingredients; track ingredient) {
                        <div class="tw-flex tw-flex-row tw-justify-between tw-text-xs tw-text-gray-600">
                            <span>{{ ingredient.type === 'removed' ? '-' : '+' }} {{ ingredient.quantity !== undefined && ingredient.quantity > 1 ? ingredient.quantity + 'x' : '' }} {{ ingredient.name }}</span>
                            @if(ingredient.price_difference) {
                                <span>{{ (saleItem?.quantity || 0) * (ingredient.price_difference || 0) * (ingredient.quantity || 0) | tilbyCurrency }}</span>
                            }
                        </div>
                    }
                    <div class="sale-item-notes">{{saleItem.notes}}</div>
                    @if(saleItem.type === 'refund') {
                        <div class="">{{saleItem.refund_cause_description}}</div>
                    }
                    @for(pc of saleItem.price_changes; track pc) {
                        <div class="tw-flex tw-flex-row">
                            <div style="width: 100%">
                                <div class="tw-flex tw-justify-between">
                                    <span class="tw-flex tw-flex-row tw-flex-1">{{priceChangeDescription(pc)}}</span>
                                    @if(pc.amount) {
                                        <div class="tw-text-right">{{ pc.amount | tilbyCurrency }}</div>
                                    }
                                </div>
                            </div>
                        </div>
                    }
                    <div class="tw-italic">{{saleItem.seller_name}}</div>
                </div>
            }

            @for(priceChange of sale?.price_changes; track priceChange) {
                @if(priceChange.type !== 'disc_perc_nd') {
                    <div title="etichetta_sconto_sul_tot" class="tw-flex tw-flex-row tw-py-5">
                        <div style="width: 100%">
                            <div class="tw-flex tw-justify-between">
                                <div>{{priceChangeDescription(priceChange)}}</div>
                                @if(priceChange.amount) {
                                    <div class="tw-text-right">{{ priceChange.amount | tilbyCurrency }}</div>
                                }
                            </div>
                        </div>
                    </div>
                }
            }
        </div>
        <mat-divider></mat-divider>
        @if(hasPayments(sale)) {
            <div id="pagamenti" class="tw-py-6 tw-px-6">
                <div class="tw-text-sm tw-text-black tw-px-2 tw-py-1 tw-rounded tw-w-min tw-bg-green-200 tw-font-bold" translate>HISTORY.SALES.DETAIL.PAYMENTS</div>
                @if(sale?.payments?.length) {
                    <div title="etichetta_tot_pagato" class="tw-py-4 tw-justify-between tw-mt-0.5">
                        @for(payment of sale?.payments; track payment) {
                            <div class="tw-flex tw-flex-row tw-pt-4">
                                <div class="tw-flex tw-flex-1">{{payment.payment_method_name}}</div>
                                <div class="">{{ payment.amount | tilbyCurrency }}</div>
                            </div>
                        }
                        @if(sale?.change) {
                            <div class="tw-flex tw-flex-row tw-pt-4">
                                <div class="tw-flex tw-flex-1" translate>HISTORY.SALE.CHANGE</div>
                                <div class="">{{ sale?.change||0 | tilbyCurrency }}</div>
                            </div>
                        }
                    </div>
                }
            </div>
        }

    </div>
